export default {
    init() {
      // scripts here run on the DOM load event
      var $erGrid = jQuery('.width-wrapper');

      $erGrid.imagesLoaded(function () {
        $erGrid.masonry({
          // options
          itemSelector: '.grid-item',
          fitWidth: true,
          columnWidth: 300,
          gutter: 20,
        });
      });

    },
    finalize() {
      // scripts here fire after init() runs
    },
  };


// WEBPACK FOOTER //
// ./scripts/routes/pageTemplatePageEducationalResources.js